








































































































































































































































































































































































import _ from 'lodash';
import {
  defineComponent,
  computed,
  Ref,
  ref,
  toRefs,
  onMounted,
  onUnmounted,
  reactive,
  watch,
  nextTick,
  getCurrentInstance,
} from '@vue/composition-api';
import {
  CloseCircleFilledIcon,
  SearchIcon,
  RefreshIcon,
  DeleteIcon,
  HistoryIcon,
  MinusCircleIcon,
  SettingIcon,
  PreciseMonitorIcon,
  LockOnIcon,
  FileCopyIcon,
} from 'tdesign-icons-vue';

// 引入组件
import addUser from '@/renderer/views/desktop/ManageConsole/UserManagement/components/userConfig.vue';
import addUserFinishDialog from '@/renderer/views/desktop/ManageConsole/UserManagement/components/addUserFinishDialog.vue';
import userRoleConfig from '@/renderer/components/user/components/userRoleConfig.vue';
import importUserDialog from '@/renderer/views/desktop/ManageConsole/UserManagement/innerUser/components/importUserDialog.vue';
import importingDialog from '@/renderer/views/desktop/ManageConsole/UserManagement/innerUser/components/importingDialog.vue';
import importResultDialog from '@/renderer/views/desktop/ManageConsole/UserManagement/innerUser/components/importResultDialog.vue';
import dataTransferDialog from '@/renderer/views/desktop/ManageConsole/UserManagement/innerUser/components/dataTransfer.vue';
import InviteDialog from '@/renderer/views/desktop/ManageConsole/UserManagement/innerUser/components/InviteDialog.vue';
import InitUserDataDialog from '@/renderer/views/desktop/ManageConsole/UserManagement/components/initUserDataDialog.vue';

// 引入 compositions
import listOperateHandler from '@/renderer/scripts/composition/listOperateHandler';
import listHandler from '@/renderer/views/desktop/ManageConsole/UserManagement/innerUser/compositions/listHandler';
import submitHandler from '@/renderer/views/desktop/ManageConsole/UserManagement/innerUser/compositions/submitHandler';
import actionHandler from '@/renderer/views/desktop/ManageConsole/UserManagement/innerUser/compositions/actionHandler';
import importHandler from '@/renderer/views/desktop/ManageConsole/UserManagement/innerUser/compositions/importHandler';
import { setResizableColumns } from '@/renderer/scripts/composition/tableResizeHandler';
import passwordHandler from '@/renderer/components/user/compositions/passwordHandler';

// 引入工具类
import { phoneCompose, getNameTipsDetail } from '@/renderer/scripts/utils/tools/index';
import tips from '@/renderer/scripts/utils/tips';
import { SMH } from '@/renderer/scripts/smh';
import { userRole } from '@/renderer/scripts/utils/ConstantConfig/ConstantI18NConfig';
import ipc from '@/renderer/scripts/utils/ipc';
import { checkRoleIsAdmin } from '@/renderer/scripts/utils/UserRole';
import i18n, { i18n_t } from '@/locales/i18n';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';

type SubmitInfo = {
  userId?: number;
  form: SMH.CreateUserParams | SMH.UpdateUserParams;
  newForm?: SMH.CreateUserParams | SMH.UpdateUserParams;
};
export default defineComponent({
  components: {
    CloseCircleFilledIcon,
    SearchIcon,
    RefreshIcon,
    SettingIcon,
    LockOnIcon,
    FileCopyIcon,
    DeleteIcon,
    HistoryIcon,
    MinusCircleIcon,
    PreciseMonitorIcon,
    addUser,
    addUserFinishDialog,
    InitUserDataDialog,
    userRoleConfig,
    importUserDialog,
    importingDialog,
    importResultDialog,
    dataTransferDialog,
    InviteDialog,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = context.root.$store;
    const currentUser = computed(() => context.root.$store.getters.userBaseInfo);
    const {
      keyword,
      columns,
      loading,
      tableData,
      pageData,
      sort,
      searchStatus,
      methods: listMethods,
    } = listHandler(currentUser);
    // 列表操作
    const {
      operateShowMap,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      isFourthButtonHover,
      isFifthButtonHover,
      isSixthButtonHover,
      hoverIndex,
      methods: listOperateMethods,
    } = listOperateHandler(tableData);
    const { userId, userInfo, createUser, updateUser } = submitHandler();
    const {
      deleteUsers,
      setUserEnabled,
      setUserRole,
      deleteUsersFn,
      activeUser,
      deleteItem,
      seletedUsers,
      noPersonalSpace,
    } = actionHandler();
    const { getResetToken, createResetToken } = passwordHandler();
    const resizeColumns = ref(setResizableColumns(columns));

    const showDialog = reactive<Record<string, boolean>>({
      inviteUser: false,
      addUser: false,
      addUserFinished: false,
      // 新建成功弹窗
      initUserRest: false,
      // 邀请用户初始化密码弹窗
      deleteUser: false,
      changeRole: false,
      transferData: false,
      import: false,
      importing: false,
      imported: false,
    });

    // 批量导入弹窗
    const { uploadInfo, task, resultList, initUpload, beforeUpload, cancelCheck, cancelUpload, confrimImport } =
      importHandler();
    const uploadMethods = {
      beforeUpload,
      cancelCheck,
      initUpload,
    };
    const opType: Ref<string> = ref('');
    const currentIsSuperAdmin = computed(() => currentUser.value.role === 'superAdmin');
    const currentIsSysAdmin = computed(() => currentUser.value.role === 'admin');
    const currentIsAdmin = computed(() => currentIsSuperAdmin.value || currentIsSysAdmin.value);
    const isEnterprise = computed(() => store.getters.editionFlag === 'enterprise');
    const isTeam = computed(() => store.getters.editionFlag === 'team');
    // 企业版超管或系管
    const isEnterpriseAdmin = computed(() => isEnterprise.value && currentIsAdmin.value);
    // 团队版超管
    const isTeamSuperAdmin = computed(() => isTeam.value && currentIsSuperAdmin.value);
    // 私有化
    const isPrivate = computed(() => store.getters.isPrivate);

    /**
     * 按钮展示规则
     * 【团队版】
     *  超管：展示邀请企业成员、新建用户按钮
     *  系统管理员：三个按钮均不展示
     * 【企业版】
     *  超管：展示邀请企业成员、新建用户、批量导入按钮；
     *  系统管理员：展示邀请企业成员、新建用户、批量导入按钮
     **/
    const inviteBtnShow = computed(() => (isEnterpriseAdmin.value || isTeamSuperAdmin.value) && !isPrivate.value);
    const addBtnShow = computed(
      () =>
        (store.getters.allowPhoneLogin || store.getters.onlyPasswordLogin) &&
        (isEnterpriseAdmin.value || isTeamSuperAdmin.value),
    );
    const batchBtnShow = computed(
      () =>
        (store.getters.allowPhoneLogin || store.getters.onlyPasswordLogin) &&
        currentIsAdmin.value &&
        isEnterprise.value,
    );

    // 启用按钮
    // eslint-disable-next-line max-len
    const showEnableBtn = computed(
      () => tableData.selectedList.length > 1 || tableData.selectedList.every((item: any) => !item.enabled),
    );
    /* const enableDisabled = computed(
      () =>
        (tableData.selectedList.length > 1 && tableData.selectedList.some((item: any) => item.enabled)) ||
        tableData.selectedList.some((item: any) => item.inactive),
    ); */
    // 禁用启用；选择的全部都是启用
    const enableDisabled = computed(() => tableData.selectedList.every((item: any) => item.enabled));
    // 禁用冻结；选择的全部都是冻结
    const freezeDisabled = computed(() => tableData.selectedList.every((item: any) => !item.enabled));
    // 冻结按钮
    // eslint-disable-next-line max-len
    const showFreezeBtn = computed(
      () => tableData.selectedList.length > 1 || tableData.selectedList.every((item: any) => item.enabled),
    );
    /* const freezeDisabled = computed(
      () =>
        (tableData.selectedList.length > 1 && tableData.selectedList.some((item: any) => !item.enabled)) ||
        tableData.selectedList.some((item: any) => item.inactive),
    ); */

    const resetToken = ref('');

    const newUserInfo = reactive({
      nickname: '',
      accountName: '',
      accountPassword: '',
    });
    const methods = {
      deleteItemEvent(row: SMH.UserBaseInfo) {
        deleteItem(row, {
          transferData: () => methods.toggleDialog('transferData', true),
          directDelte: () => {
            listMethods.pullUserList();
          },
        });
      },
      deleteUsersFnEvent() {
        deleteUsersFn(tableData, {
          transferData: () => methods.toggleDialog('transferData', true),
          directDelte: () => {
            listMethods.pullUserList();
          },
        });
      },
      // 新建
      async createUserFn() {
        const canAddUser = await store.dispatch('checkUserCount');
        if (!canAddUser) return;
        opType.value = 'add';
        userInfo.value = {};
        userId.value = null;
        methods.toggleDialog('addUser', true);
      },
      // 邀请用户弹窗
      async inviteUser() {
        const canAddUser = await store.dispatch('checkUserCount');
        if (!canAddUser) return;
        methods.toggleDialog('inviteUser', true);
      },
      // 管理=修改
      manage(row: SMH.UserBaseInfo) {
        if (methods.manageDisabled(row)) return;
        opType.value = 'update';
        userInfo.value = _.cloneDeep(row);
        (userInfo.value as SMH.UserBaseInfo).email =
          (userInfo.value as SMH.UserBaseInfo).email === 'null' ? '' : (userInfo.value as SMH.UserBaseInfo).email;
        userId.value = row.id as number;
        methods.toggleDialog('addUser', true);
      },
      // 复制信息邀请改密码
      async copyInviteItem(row: SMH.UserBaseInfo) {
        resetToken.value = '';
        if (methods.copyBtnDisabled(row)) return;
        userInfo.value = _.cloneDeep(row);
        // 获取resetToken
        const tokenInfo = await getResetToken(row.id as number);
        if (!tokenInfo) {
          resetToken.value = await createResetToken(row.id as number);
        } else {
          resetToken.value = tokenInfo.token;
        }
        // 没有重置token就不需要打开弹窗
        if (resetToken.value) {
          methods.toggleDialog('initUserRest', true);
        }
      },

      // 管理按钮不可用
      manageDisabled(row: any) {
        // 未激活用户不可用管理
        if (row.inactive) {
          return true;
        }
        // 超管 可以管理任何人
        if (currentIsSuperAdmin.value) {
          return false;
        }
        // 普管 不能管理其他管理员包括超管,可以管理自己
        if (currentUser.value.role === 'admin') {
          return row.role !== 'user' && row.id !== currentUser.value.userId;
        }
        // 其他
        return true;
      },
      // 删除按钮不可用
      deleteDisabled(row: any) {
        // 自己不能删除自己
        if (currentUser.value.userId === row.id) return true;
        // 超管
        if (currentIsSuperAdmin.value) {
          return row.role === 'superAdmin';
        }
        // 普管 不能删除其他管理员包括超管
        if (currentUser.value.role === 'admin') {
          return checkRoleIsAdmin(row.role, true);
        }
        // 其他
        return true;
      },
      // 启用、冻结按钮不可用
      enableBtnDisabled(row: any) {
        if (row.inactive) {
          return true;
        }
        return methods.deleteDisabled(row);
      },
      // 复制初始化信息不可用
      copyBtnDisabled(row: any) {
        // 自己不能操作自己
        if (currentUser.value.userId === row.id) return true;
        // 系管只能操作普通用户
        if (currentIsSysAdmin.value && row.role !== 'user') return true;
        return false;
      },
      // 保存
      async onSaveSubmit({ type, info }: { type: 'add' | 'update'; info: SubmitInfo }) {
        let isSuccessful;
        if (type === 'add') {
          const addForm = _.cloneDeep(info.form);
          isSuccessful = await createUser(addForm as SMH.CreateUserParams);
          reporter.report('background_user_manage', {
            add_type: 'single',
            add_result: isSuccessful ? 1 : 0,
          });
        } else {
          const { userId, form } = info;
          const allowPersonalSpaceChanged =
            (userInfo.value as SMH.UserBaseInfo).allowPersonalSpace !== form.allowPersonalSpace;
          const capacityChanged = (userInfo.value as SMH.UserBaseInfo).capacity !== form.personalSpaceQuotaSize;
          const accountNameChanged = (userInfo.value as SMH.UserBaseInfo).accountName !== form.accountName;
          const originAccountName = (userInfo.value as SMH.UserBaseInfo).accountName;
          const params = {
            userId: userId as number,
            form: form as SMH.UpdateUserParams,
            allowPersonalSpaceChanged,
            capacityChanged,
            originAccountName,
            accountNameChanged,
          };
          isSuccessful = await updateUser(params);
          // 修改当前用户信息后，右上角需要刷新
          if (isSuccessful && userId === currentUser.value.userId) {
            ipc.emit(ipc.RENDERER_EVENTS_MAP.CURRENT_USER_INFO_CHANGED);
            store.commit('SET_BASEINFO', form);
            await store.dispatch('checkPersonalSpace');
          }
        }
        if (isSuccessful) {
          methods.toggleDialog('addUser', false);
          listMethods.pullUserList();
          // 刷新企业剩余额度
          store.dispatch('GetOrgSpace');
          // 新建成功后打开新建成功的弹窗

          // 新增账号用户成功后才弹窗
          if (type === 'add' && store.getters.onlyPasswordLogin) {
            nextTick(() => {
              const { nickname, accountName, accountPassword } = info.form as SMH.CreateUserParams;
              Object.assign(newUserInfo, {
                nickname,
                accountName,
                accountPassword,
              });
              showDialog.addUserFinished = true;
            });
          }
        }
      },
      // 设置冻结 启用
      async setEnabled(enabled: boolean, row?: any) {
        if (row && methods.enableBtnDisabled(row)) return;
        const list = row ? [row] : tableData.selectedList;
        const tip = row
          ? i18n_t('确定要{slot1}{slot2}吗？', {
              slot1: enabled ? i18n_t('启用') : i18n_t('冻结'),
              slot2: row.nickname,
            })
          : i18n_t('确定要{slot1}所选的{slot2}个用户吗？', {
              slot1: enabled ? i18n_t('启用') : i18n_t('冻结'),
              slot2: list.length,
            });
        const dialog = CustomDialog.confirm({
          theme: 'warning',
          header: tip,
          body: `${enabled ? i18n_t('启用后，账号将恢复使用') : i18n_t('冻结后，账号将无法登录')}`,
          async onConfirm() {
            if (dialog.hide) {
              dialog.hide();
            }
            const isSuccessful = await setUserEnabled(list, enabled);
            if (isSuccessful) {
              listMethods.pullUserList();
            }
          },
        });
      },
      // 切换身份
      async onSaveRole(role: string) {
        const isSuccessful = await setUserRole(tableData.selectedList, role);
        if (isSuccessful) {
          methods.toggleDialog('changeRole', false);
          listMethods.pullUserList();
        }
      },
      // 激活用户;需要用户(已经绑定手机号 || isAccountNotDependentOnPhone不依赖绑定手机号)且未激活的状态
      async activeUser(row: any) {
        const isSuccessful = await activeUser(row.id);
        if (isSuccessful) {
          listMethods.pullUserList();
        }
      },
      // 开启批量导入
      async openImport() {
        const canAddUser = await store.dispatch('checkUserCount');
        if (!canAddUser) return;
        // 弹出批量导入时，初始化信息
        initUpload();
        reporter.report('batch_import_users');
        methods.toggleDialog('import', true);
      },
      /*
       *
       *批量导入
       * * */
      // 确定导入用户
      async importSubmit() {
        try {
          methods.toggleDialog('importing', true);
          context.emit('submit');
          const res = await confrimImport();
          if (res.result) {
            resultList.value = res.result;
            methods.toggleDialog('importing', false);
            methods.toggleDialog('imported', true);
            // 导入完成刷新列表
            listMethods.pullUserList();
          }
          reporter.report('background_user_manage', {
            add_type: 'batch',
            add_result: res.result ? 1 : 0,
          });
        } catch (e) {
          tips.error(i18n_t('导入失败'));
          reporter.report('background_user_manage', {
            add_type: 'batch',
            add_result: 0,
          });
        }
      },
      // 完成上传,关闭弹窗
      uploadFinish() {
        methods.toggleDialog('imported', false);
        methods.toggleDialog('import', false);
      },
      // 再次上传,回到初始化
      uploadAgain() {
        methods.toggleDialog('imported', false);
        initUpload();
      },
      // 上传过程中取消上传
      async cancelUploadFn() {
        await cancelUpload();
        methods.toggleDialog('importing', false);
        methods.toggleDialog('imported', true);
      },
      toggleDialog(key: string, value: boolean) {
        showDialog[key] = value;
      },
    };
    watch(
      () => store.getters.remainingSpaceQuota,
      val => {
        listMethods.pullUserList();
      },
    );
    onMounted(() => {
      if (context.root.$route.params?.action === 'openImport') {
        methods.openImport();
      }
      listMethods.pullUserList();
      ipc.on(ipc.RENDERER_EVENTS_MAP.USER_INFO_CHANGE, listMethods.pullUserList);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.USER_INFO_CHANGE, listMethods.pullUserList);
    });
    return {
      currentUser,
      currentIsSuperAdmin,
      currentIsSysAdmin,
      currentIsAdmin,
      inviteBtnShow,
      searchStatus,
      addBtnShow,
      batchBtnShow,
      resizeColumns,
      loading,
      userRole,
      keyword,
      ...toRefs(tableData),
      ...toRefs(pageData),
      sort,
      showDialog,
      seletedUsers,
      noPersonalSpace,
      newUserInfo,
      resetToken,

      operateShowMap,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      isFourthButtonHover,
      isFifthButtonHover,
      isSixthButtonHover,
      hoverIndex,
      listOperateMethods,
      showEnableBtn,
      showFreezeBtn,
      enableDisabled,
      freezeDisabled,
      opType,
      userId,
      userInfo,
      ...methods,
      listMethods,
      phoneCompose,
      getNameTipsDetail,
      createUser,
      updateUser,
      deleteUsers,
      setUserEnabled,
      uploadInfo,
      task,
      resultList,
      uploadMethods,
      initUpload,
      cancelUpload,
      confrimImport,
    };
  },
});
